<template>
  <div>
    <div v-if="errorMsg" class="alert push-30-t alert-danger alert-dismissable">
      <p>{{errorMsg}}</p>
    </div>
    <div class="form-group">
      <div class="car-form__selects-list">

        <div class="form-material">
		      <label for="manufacturier">{{ labelFieldEvName[actualLanguage] }}</label>
          <input :disabled="savingCar" type="text" v-model="carModel.carName">
        </div>

        <div v-if="carModel.carName" class="form-material">
          <label for="manufacturier">{{ labelFieldManufacturer[actualLanguage] }}</label>
          <select @change='onManufacturerChange' :disabled="savingCar" v-model="carModel.manufacturer">
            <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
            <option v-for="manufacturer in manufacturers" :value="manufacturer">{{manufacturer}}</option>
          </select>
        </div>


        <template v-if="evseFlag">
          <div v-if="filteredYears.length" class="form-material">
            <label for="manufacturier">{{ labelFieldLevel[actualLanguage] }}</label>
            <select @change='onYearChange' :disabled="savingCar" v-model="carModel.year">
              <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
              <option v-for="year in filteredYears" :value="year">{{year}}</option>
            </select>
          </div>

          <div v-if="filteredModels.length" class="form-material">
            <label for="manufacturier">{{ labelFieldEVSEBrand[actualLanguage] }}</label>
            <select @change='onModelChange' :disabled="savingCar" v-model="carModel.model">
              <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
              <option v-for="model in filteredModels" :value="model">{{model}}</option>
            </select>
          </div>

          <div v-if="filteredColors.length" class="form-material">
            <label for="manufacturier">{{ labelFieldEVSEModel[actualLanguage] }}</label>
            <select :disabled="savingCar" v-model="carModel.color">
              <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
              <option v-for="color in filteredColors" :value="color">{{color}}</option>
            </select>
          </div>
        </template>

        <template v-else> 
          <div v-if="filteredYears.length" class="form-material">
            <label for="manufacturier">{{ labelFieldEVYear[actualLanguage] }}</label>
            <select @change='onYearChange' :disabled="savingCar" v-model="carModel.year">
              <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
              <option v-for="year in filteredYears" :value="year">{{year}}</option>
            </select>
          </div>
        
          <div v-if="filteredModels.length" class="form-material">
            <label for="manufacturier">{{ labelFieldEVModel[actualLanguage] }}</label>
            <select @change='onModelChange' :disabled="savingCar" v-model="carModel.model">
              <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
              <option v-for="model in filteredModels" :value="model">{{model}}</option>
            </select>
          </div>

          <div v-if="filteredColors.length" class="form-material">
            <label for="manufacturier">{{ labelFieldEVColor[actualLanguage] }}</label>
            <select :disabled="savingCar" v-model="carModel.color">
              <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
              <option v-for="color in filteredColors" :value="color">{{color}}</option>
            </select>
          </div>
        </template>


        <div v-if="carModel.color" class="form-material">
          <label for="deviceSelect">{{ labelFieldLinkModule[actualLanguage] }}</label>
          <select :disabled="savingCar" class="device-select" id="deviceSelect" v-model="carModel.linkedDevice">
            <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
            <option v-for="device in devices" :value="device.deviceId">{{device.deviceId}}</option>
          </select>
        </div>

        <div v-if="carModel.linkedDevice" class="form-material">
          <label for="deviceSelect">{{ labelFieldLinkPort[actualLanguage] }}</label>
          <select :disabled="savingCar" class="device-select" id="deviceSelect" v-model="carModel.linkedPort">
            <option value="">{{ labelFieldSelect[actualLanguage] }}</option>
            <option v-for="model in [1,2,3,4,5,6]" :value="model">{{model}}</option>
          </select>
        </div>

        <div v-if="carModel.averageWhPerKm" class="form-material">
          <label for="deviceSelect">{{ labelFieldEVConsumption[actualLanguage] }}</label>
          <input :disabled="savingCar" type="text" v-model="carModel.averageWhPerKm">
        </div>		
		
		
      </div>
    </div>
    <div class="form-group">
      <button @click="save" class="btn btn-success btn-rounded btn-save" style="width: 110px" type="button" name="button">
        <spinner size="small" v-if="savingCar"></spinner>
        <span v-else>{{ labelFieldButtonSave[actualLanguage] }}</span>
      </button>
      <button v-if="car !== undefined" @click="showConfirmationModal" class="btn btn-danger btn-rounded" type="button" name="button">{{ labelFieldButtonDelete[actualLanguage] }}</button>
    </div>
  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'CarForm',
  components: {
    Spinner
  },
  props: ['car'],
  data() {
    return {
      errorMsg: '',
      savingCar: false,
      evseFlag: false,
      filteredYears: [],
      filteredModels: [],
      filteredColors: [],
      filteredCarPool: [],
      carModel: {
        manufacturer: '',
        color: '',
        year: '',
        model: '',
        carName: '',
        linkedDevice: '',
        linkedPort:   '',
        averageWhPerKm: '',
        // averageLtPerKm: 10.2
      },

      actualLanguage : "FR",
      labelFieldEvName: {FR: 'Nom du Véhicule/Borne', EN: 'Vehicle/Charger Name'},
      labelFieldManufacturer: {FR: 'Manufacturier', EN: 'Manufacturer'},
      labelFieldSelect: {FR: 'Choisir', EN: 'Select'},
      labelFieldLevel: {FR: 'Niveau', EN: 'Level'},
      labelFieldEVSEBrand: {FR: 'Marque de borne', EN: 'EVSE Brand'},
      labelFieldEVSEModel: {FR: 'Type/Modèle', EN: 'Model'},
      labelFieldEVYear: {FR: 'Année', EN: 'Year'},
      labelFieldEVModel: {FR: 'Modèle', EN: 'Model'},
      labelFieldEVColor: {FR: 'Couleur', EN: 'Color'},
      labelFieldLinkModule: {FR: 'Module accosié à la recharge', EN: 'Linked module'},
      labelFieldLinkPort: {FR: 'Port associé à la recharge', EN: 'Linked port'},
      labelFieldEVConsumption: {FR: 'Consommation (Wh/km)', EN: 'Consumption (Wh/)'},
      labelFieldButtonSave: {FR: 'Sauvegarder', EN: 'Save'},
      labelFieldButtonDelete: {FR: 'Supprimer', EN: 'Delete'},
      labelField: {FR: '', EN: ''},
    }
  },
  methods: {
    getCarDataToSave() {
      let car = _.find(this.filteredCarPool, (car) => {
        return car.model == this.carModel.model &&
               car.color == this.carModel.color &&
               car.manufacturer == this.carModel.manufacturer &&
               car.year == this.carModel.year;
      })
      return car;
    },
    showConfirmationModal() {
      if (this.actualLanguage == "FR"){
        if (window.confirm(`Le véhicule "${this.carModel.carName}" sera supprimé. Cette opération est irréversible.`)){
          this.deleteCar()
        }
        }else{
        if (window.confirm(`The vehicle "${this.carModel.carName}" will be deleted. This operation is not reversible.`)){
          this.deleteCar()
        }
      }

    },
    deleteCar() {
      this.$store.dispatch('carsStore/deleteCar', this.carModel.profileCarId)
      .then((response) => {
        this.$store.dispatch('overlayStore/pushNotification', {text: "Véhicule supprimer", type: 'success'})
        this.refresh()
      })
      .catch((error) => {
        this.$store.dispatch('overlayStore/pushNotification', {text: "Erreur lors de la suppression", type: 'danger'})
      })
    },
    save() {
      let carData = this.getCarDataToSave()
      if (this.car && carData) {
        carData.carName = this.carModel.carName

        this.savingCar = true
        carData.profileCarId = this.carModel.profileCarId
		    carData.averageWhPerKm = this.carModel.averageWhPerKm
        carData.linkedPort   = this.carModel.linkedPort
        carData.linkedDevice = this.carModel.linkedDevice

        this.$store.dispatch('carsStore/updateCar', carData).then((response) => {
          this.$store.dispatch('overlayStore/pushNotification', {text: "Véhicule sauvegardé", type: 'success'})
          this.savingCar = false
        }).catch((error) => {
          this.$store.dispatch('overlayStore/pushNotification', {text: "Erreur lors de la sauvegarde", type: 'danger'})
          console.log('error on updating car', error);
          this.savingCar = false
        })
      } else if (carData) {
        carData.linkedDevice = this.carModel.linkedDevice
        carData.linkedPort   = this.carModel.linkedPort
        carData.carName      = this.carModel.carName
		    carData.averageWhPerKm      = this.carModel.averageWhPerKm
        this.savingCar = true
        this.$store.dispatch('carsStore/createCar', carData)
        .then((response) => {
          this.$store.dispatch('overlayStore/pushNotification', {text: "Véhicule sauvegardé", type: 'success'})
          this.$store.dispatch('overlayStore/toggleModal',false)
          this.refresh()
          this.savingCar = false
        })
        .catch((error) => {
          this.$store.dispatch('overlayStore/pushNotification', {text: "Erreur lors de la sauvegarde", type: 'danger'})
          this.savingCar = false
          console.log('error on creating car', error);
        })
      } else {
        this.$store.dispatch('overlayStore/pushNotification', {text: "Le formulaire contient des erreurs", type: 'danger'})
      }
    },
    onManufacturerChange(e) {

      if (e) this.resetData();
      if(this.carModel.manufacturer=="Borne de recharge") 
      {this.evseFlag = true;}else{this.evseFlag = false;}

      return this.$store.dispatch('carsStore/getManufacturerInfos', { manufacturer: this.carModel.manufacturer })
      .then((response) => {
        this.filteredCarPool = response.data
        this.filteredYears   = _.uniq(_.map(response.data, (object) => { return object.year; }))
        return Promise.resolve();
      })
    },
    onYearChange() {
      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.carModel.manufacturer,
        year: this.carModel.year
      }).then((response) => {
        this.filteredCarPool = response.data
        this.filteredModels = _.uniq(_.map(response.data, (object) => { return object.model; }))
        return Promise.resolve();
      })
    },
    onModelChange() {
      return this.$store.dispatch('carsStore/getManufacturerInfos', {
        manufacturer: this.carModel.manufacturer,
        year: this.carModel.year,
        model: this.carModel.model,
        whPerKm: this.carModel.averageWhPerKm
      }).then((response) => {
        this.filteredCarPool = response.data
        this.filteredColors = _.uniq(_.map(response.data, (object) => { return object.color; }))
        return Promise.resolve();
      })
    },
    resetData() {
      this.filteredYears = []
      this.filteredModels = []
      this.filteredColors = []
      this.carModel.year = ''
      this.carModel.color = ''
      this.carModel.model = ''
      this.carModel.linkedPort   = ''
      this.carModel.linkedDevice = ''
    },
    fillDefaultData() {
      this.carModel.profileCarId = this.car.profileCarId
      this.carModel.manufacturer = this.car.manufacturer
      this.carModel.color        = this.car.color
      this.carModel.model        = this.car.model
      this.carModel.year         = this.car.year
      this.carModel.carName      = this.car.carName
      this.carModel.linkedDevice = this.car.linkedDevice
      this.carModel.linkedPort   = this.car.linkedPort
	    this.carModel.averageWhPerKm   = this.car.averageWhPerKm
      this.onManufacturerChange()
      .then(this.onYearChange)
      .then(this.onModelChange)
    },
    refresh() {
      this.$store.dispatch('carsStore/getCars').then(() => {this.fillDefaultData()})
      this.$emit('refresh')
    }
  },
  computed: {
    ...mapState('carsStore', ['cars', 'manufacturers']),
    ...mapState('devicesStore', ['devices'])
  },
  created() {
    this.$store.dispatch('devicesStore/devices')
    if (this.car) {
      this.fillDefaultData()
    }
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

  }
}
</script>



// WEBPACK FOOTER //
// CarForm.vue?febe1bbe